/**
 * Dependencies
 */
import http from '../../../../services/HttpService'

/**
 * Get the projects scoped with the inbox query parameter
 *
 * @param  {Function} options.commit
 * @return {Promise}
 */
const getProjects = ({ commit }) => {
    commit('SET_PENDING')
    http.get('projects/?scope=inbox')
        .then(res => commit('GET_PROJECTS_SUCCESS', res.data))
        .catch(err => commit('GET_PROJECTS_FAILURE', err))
}

export default {
    getProjects
}



// WEBPACK FOOTER //
// ./src/state/modules/projects/inbox/actions.js